<script>
    /*
    	VerticalSelectedButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiClose } from '@mdi/js';

    export let category;
    export let onClick;

    onMount(() => {
    })

</script>

<style>
    .selected-cat-button {
        width: fit-content;
        min-width: 125px;
        margin-bottom: 10px;
        padding: 5px 20px 6px 20px;
        font-size: 13px;
        color: var(--tcui-primary);
        background-color: #DFCDD8;
        border: none;
        border-radius: 18px;
    }

    .selected-cat-button:hover {
        background-color: #D3DDF9;
    }

    .selected-cat-button .button-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .selected-cat-button .close-icon {
        width: 20px;
        height: 20px;
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    :global(.selected-cat-button .close-icon svg) {
        width: 20px;
        height: 20px;
        fill: var(--tcui-primary);
        outline: none;
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<button class="selected-cat-button" on:click={() => onClick(category)}>
    <div class="button-content">
        {category.label}
        <div class="close-icon">
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiClose} /></Icon>
        </div>
    </div>
</button>

